.card {
  background: var(--ps-bg-card);
  border-radius: var(--ps-radius-xl);
  overflow: hidden;
  border: 1px solid var(--ps-border-default);
  transition:
    transform 0.25s var(--ps-ease-default),
    box-shadow 0.25s var(--ps-ease-default),
    border-color 0.25s var(--ps-ease-default);
  display: flex;
  flex-direction: column;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
}

.card:hover {
  transform: translateY(-4px);
  border-color: var(--ps-gold);
  box-shadow: var(--ps-shadow-card-hover);
}

.card:active {
  transform: translateY(-2px);
}

.media {
  width: 100%;
  aspect-ratio: 7 / 4;
  background: var(--ps-bg-elevated);
  overflow: hidden;
  position: relative;
}

.media img,
.media video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: opacity 0.4s ease;
}

.media video {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}

.placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--ps-text-sm);
  color: var(--ps-text-muted);
  font-weight: 500;
}

.body {
  padding: 20px 22px 24px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.name {
  font-size: var(--ps-text-lg);
  font-weight: 700;
  letter-spacing: -0.02em;
  margin-bottom: 10px;
}

.desc {
  font-size: 13px;
  line-height: 1.55;
  color: var(--ps-text-muted);
  flex: 1;
  margin: 0;
}

.entities {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 14px;
}

.entity {
  font-size: 10px;
  font-weight: 500;
  color: var(--ps-text-secondary);
  background: var(--ps-bg-elevated);
  border: 1px solid var(--ps-border-default);
  border-radius: var(--ps-radius-pill);
  padding: 2px 8px;
}

.footer {
  padding: 0 22px 18px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.badge {
  font-size: 10px;
  font-weight: 600;
  border-radius: var(--ps-radius-pill);
  padding: 3px 8px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.badgeAddon {
  color: var(--ps-addon-fg);
  background: var(--ps-addon-bg);
}

.badgeLicensed {
  color: var(--ps-licensed-fg);
  background: var(--ps-licensed-bg);
}

.badgeLocked {
  color: var(--ps-locked-fg);
  background: var(--ps-locked-bg);
}

.arrow {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--ps-bg-elevated);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background var(--ps-duration-base);
  margin-left: auto;
}

.card:hover .arrow {
  background: var(--ps-bg-hover);
}
